<template>
	<div class="w100 bg-white flex-between" style="height: 90px; min-width: 1300px;">
		<img src="../../static/img/logo-transverse.png" style="height: 90px;">
		<div class="flex-start align-center mr30" style="line-height: 28px;">
			<img src="../../static/img/head-default.png" class="user-head60" />
			<router-link :to="{name:'admin-user-info'}">{{currentUser.name}}</router-link>
			<router-link :to="{name:'admin-user-info'}">
				<van-icon name="phone" class="f-light-gray ml10" />{{currentUser.tel}}
			</router-link>
			<a class="ml10" href="javascript:void(0);" @click="onExit()">退出</a>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentUser: {
					name: '',
					tel: '',
					uid: 0
				}
			}
		},
		created() {
			let temp = this.$cookie.getUser();
			if (temp != null) {
				this.currentUser = temp;
			}

			if (this.currentUser.uid <= 0) {
				this.onExit();
			}
		},
		methods: {
			onExit() {
				var _this = this;
				_this.$cookie.delUser(() => {
					_this.$router.replace('/admin');
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/top-admin.vue